function Header() {
    return (
        <header className="mb-6">
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">
                <a href="/" className="hover:underline">
                    Steam VAC & Friends Checker
                </a>
            </h1>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                Enter a Steam profile <span className="font-medium">vanity name</span>, a
                full <span className="font-medium">profile URL</span>, or a <span
                className="font-medium">Steam ID</span>
                {' '}(64/32/SteamID/SteamID3).
            </p>
        </header>
    );
}

export default Header;
